import { outsideClickFunc } from '@helpers/outsideClick.js';

(() => {
	const languageEls = [...document.querySelectorAll('.language-dropdown')];

	if(languageEls) {
		languageEls.forEach(languageEl => {

			const languageSwitch = languageEl.querySelector('.language-dropdown__toggle');
			const dropdownList = languageEl.querySelector('.language-dropdown__options');
			let isActive = false;

			languageSwitch.addEventListener('click', event => {
				event.preventDefault();
				toggleDropdown();
			});

			
			const toggleDropdown = () => {
				isActive = dropdownList.classList.contains('language-dropdown__options--open');
				if (isActive) {
					hideDropDown();
					outsideClickFunc(languageEl, isActive, hideDropDown);
				} else {
					showDropDown();
					outsideClickFunc(languageEl, isActive, hideDropDown);
				}
			};

			const showDropDown = () => {
				dropdownList.classList.add('language-dropdown__options--open');
			};

			const hideDropDown = () => {
				dropdownList.classList.remove('language-dropdown__options--open');
			};
		});
	}

})();